import React, { Component } from 'react';
import PropTypes from 'prop-types';


/**
 * Component that alerts if you click outside of it
 */
export default class OutsideAlerter extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    setWrapperRef(node) {
        this.wrapperRef = node;
      }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
           this.props.closeSelfSearchField();

        }
    }

    render() {
        return (        
            <div className={this.props.OutsideClassName} ref={this.wrapperRef}>
                {this.props.children}
            </div>
        )        
    }
}

OutsideAlerter.propTypes = {
    children: PropTypes.element.isRequired,
};